import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { of, switchMap } from 'rxjs';
import { SPECIAL_OFFER_ROUTES } from 'src/app/core/constants/routes-constants';
import { NotificationService } from 'src/app/core/services/notification.service';
import { SpecialOfferPopupComponent } from 'src/app/extensions/components/special-offer-popup/special-offer-popup.component';
import { SIGNAL_ITEM_KEY, SPECIAL_OFFER_STATUS } from 'src/app/extensions/constants/commonConstants';
import { FileStoreAPIService } from 'src/app/extensions/services/api/file-store-api.service';
import { SpecialOfferAPIService } from 'src/app/extensions/services/api/specialOffer-api.service';
import { GlobalService } from 'src/app/extensions/services/global.service';

@Component({
  selector: 'special-offer-card-view',
  standalone: false,
  templateUrl: './special-offer-card-view.component.html',
  styleUrl: './special-offer-card-view.component.scss',
})
export class SpecialOfferCardViewComponent {
  @Input() specialOffers: app.models.GetFilteredSpecialOfferModel[];
  @Output() deleteSpecialOffer: EventEmitter<string> = new EventEmitter<string>();
  @Output() stopSpecialOffer: EventEmitter<string> = new EventEmitter<string>();
  @Input() props: app.models.DynamicPropsDictionary;

  public specialOfferStatus = SPECIAL_OFFER_STATUS;
  private stateSignalItem: any;

  constructor(
    private _router: Router,
    private _ngbModal: NgbModal,
    private _globalService: GlobalService,
    private _specialOfferAPIService: SpecialOfferAPIService,
    private _fileStoreAPIService: FileStoreAPIService,
    private _notificationService: NotificationService,
    private _translateService: TranslateService
  ) {}

  navigateToDetailHandler(id: string) {
    this._router.navigate([SPECIAL_OFFER_ROUTES.ADMIN_SPECIAL_OFFERS, SPECIAL_OFFER_ROUTES.PREVIEW, id]);
  }

  openPopOver(e) {
    e.stopPropagation();
  }

  deleteCampaign(specialOffer: app.models.GetFilteredSpecialOfferModel) {
    const modal = this._ngbModal.open(SpecialOfferPopupComponent);
    modal.componentInstance.title = 'specialOffers.wizard.deleteCampaign.title';
    modal.result.then(result => {
      if (result) {
        this.deleteSpecialOffer.emit(specialOffer.specialOfferId);
      }
    });
  }

  duplicateCampaign(specialOffer) {
    let duplicatedSpecialOffer: app.models.GetSpecialOfferModel;
    this._specialOfferAPIService
      .getSpecialOffer(specialOffer.specialOfferId)
      .pipe(
        switchMap(response => {
          if (response.campaignImageDocument?.documentStoragePath) {
            this._fileStoreAPIService
              .getFile(response.campaignImageDocument.documentStoragePath)
              .subscribe((fileContent: string) => {
                duplicatedSpecialOffer.campaignImageSrc = `data:image/png;base64,${fileContent}`;
              });
          }
          return of(response);
        })
      )
      .subscribe(response => {
        duplicatedSpecialOffer = {
          ...response,
          startDate: undefined,
          endDate: undefined,
          specialOfferId: '',
          status: this.specialOfferStatus.DRAFT,
        };
        this.stateSignalItem = { data: { ...duplicatedSpecialOffer, isDuplicatedCampaign: true, isNewCamapign: true } };
        this._globalService.setSignalItem(SIGNAL_ITEM_KEY.SPECIAL_OFFER_DATA, this.stateSignalItem);
        this._router.navigate([
          SPECIAL_OFFER_ROUTES.ADMIN_SPECIAL_OFFERS,
          SPECIAL_OFFER_ROUTES.NEW,
          SPECIAL_OFFER_ROUTES.PREVIEW,
          '',
        ]);
      });
  }

  stopCampaign(specialOffer) {
    const modal = this._ngbModal.open(SpecialOfferPopupComponent);
    modal.componentInstance.title = 'specialOffers.wizard.stopCampaign.title';
    modal.result.then(result => {
      if (result) {
        this._specialOfferAPIService.stopCampaign(specialOffer.specialOfferId).subscribe(response => {
          if (response.isSuccess) {
            this._notificationService.showSuccess(
              this._translateService.instant('specialOffers.wizard.notification.requestStopped'),
              this._translateService.instant('common.success')
            );
            this.stopSpecialOffer.emit();
          }
        });
      }
    });
  }
}
